<template>
  <a-modal
    title="绑定手机号"
    okText="提交"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :bodyStyle="bodyStyle"
    @ok="onSubmit"
    @cancel="handleCancel"
  >
    <!-- 内容 -->
    <div class="detail-content">
      <!-- 手机号 -->
      <a-row>
        <a-col :span="leftSpan" class="modal-title">手机号码：</a-col>
        <a-col :span="rightSpan" class="modal-desc">
          <a-input
            v-model="phone"
            placeholder="请输入手机号"
            :disabled="confirmLoading"
          ></a-input>
        </a-col>
      </a-row>
      <!-- 验证码 -->
      <a-row>
        <a-col :span="leftSpan" class="modal-title">验证码：</a-col>
        <a-col :span="rightSpan" class="modal-desc">
          <a-input-search
            v-model="code"
            placeholder="请输入验证码"
            :disabled="confirmLoading"
            @search="onSendCode"
          >
            <a-button
              style="min-width: 100px;"
              slot="enterButton"
              :disabled="confirmLoading"
              :loading="isLoadingCode"
            >{{ codeMsg }}</a-button>
          </a-input-search>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>

<script>
import Pub from '@/utils/public'
import { sendSmsCode } from '@/api/hp-request'
export default {
  data () {
    return {
      leftSpan: 5,
      rightSpan: 19,
      // 显示/加载
      visible: false,
      confirmLoading: false,
      isLoadingCode: false,
      // 样式
      bodyStyle: {
        padding: '16px 24px'
      },
      // 手机号
      phone: undefined,
      // 验证码
      code: undefined,
      codeMsg: '获取验证码',
      codeTime: undefined
    }
  },
  methods: {
    // 显示
    showModal () {
      // 显示
      this.visible = true
      // 清空
      this.phone = undefined
      this.code = undefined
      this.codeMsg = '获取验证码'
      if (this.codeTime) { clearInterval(this.codeTime) }
      this.codeTime = undefined
    },
    // 隐藏
    handleCancel () {
      if (!this.confirmLoading) {
        this.visible = false
      }
    },
    // 发送验证码
    onSendCode () {
      // 有倒计时 || 正在获取 无法点击
      if (this.codeTime || this.isLoadingCode) { return }
      // 验证手机格式
      if (!Pub.REG_IS_PHONE(this.phone)) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      // 开始发送
      this.isLoadingCode = true
      this.codeMsg = ''
      sendSmsCode({ phone: this.phone, type: 1 }).then(res => {
        this.isLoadingCode = false
        const { code, message } = res
        if (code === 0) {
          // 发送成功
          var number = 59
          this.codeMsg = `${number}s`
          this.codeTime = setInterval(() => {
            if (number === 0) {
              this.codeMsg = '获取验证码'
              if (this.codeTime) { clearInterval(this.codeTime) }
              this.codeTime = undefined
            } else {
              this.codeMsg = `${number}s`
            }
            number -= 1
          }, 1000)
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.isLoadingCode = false
        this.codeMsg = '获取验证码'
        this.$message.error('获取验证码失败')
      })
    },
    // 提交
    onSubmit () {
      // 检查手机号码是否为空
      if (!this.phone) {
        this.$message.error('手机号码不能为空')
        return 
      }
      // 验证手机格式
      if (!Pub.REG_IS_PHONE(this.phone)) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      // 检查验证码是否为空
      if (!this.code) {
        this.$message.error('验证码不能为空')
        return 
      }
      this.confirmLoading = true
      setMobilePassword({ mobile: this.phone, code: this.code }).then(res => {
        this.confirmLoading = false
        const { code, message } = res
        if (code === 0) {
          this.$message.success('绑定手机号成功')
          this.handleCancel()
          this.$emit('success', this.phone)
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.confirmLoading = true
        this.$message.error('绑定手机号失败')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.detail-content {
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
}
.detail-content .ant-row:not(:first-child) {
  margin-top: 14px;
}
.modal-title {
  line-height: 32px;
  text-align: right;
}
.modal-desc {
  line-height: 32px;
}
.desc-info {
  width: 100%;
  background-color: #FAFAFA;
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8px;
}
.desc-info {
  margin-top: 14px;
  color: rgba(0, 0, 0, 0.4);
  font-size: 14px;
  line-height: 24px;
}
.modal-input {
  width: 136px;
}
</style>